import React, { useState } from "react";
import OTPInput, { ResendOTP } from "otp-input-react";
import RightArrowIcon from "../../icons/rightArrow";
import LeftArrowIcon from "../../icons/leftArrow";
import useMediaQuery from "../../hooks/useMediaQuery";
import LoadingButton from "../../components/loadingButton";
import ErrorMessage from "../../components/errorMessage";
import FillInfoIcon from "../../icons/fillInfoIcon";
import styles from "./style.module.css";


const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

const renderTime = () => React.Fragment;

const renderButton = (buttonProps) => {
  let time = formatTime(buttonProps.remainingTime);
  return (
    <div className={styles.form_content}>
      <div className={styles.form_content_icon}>
        <FillInfoIcon />
      </div>
      <div
        className={styles.form_content_inner}
      >{`Code was sent to your email address It will be valid for ${time}`}</div>
      <div className={styles.form_content_btn}>
        <button {...buttonProps}>Resend</button>
      </div>
      <div className={styles.form_extra}>
        Check your Spam if you haven't received the code
      </div>
    </div>
  );
};

const Step2 = ({
  onFormSubmit,
  onBackClick,
  onResendClick,
  loading,
  errorMessage,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [OTP, setOTP] = useState("");
  const [isTimerComplete, setIsTimerComplete] = useState(true);

  const onSubmit = () => {
    onFormSubmit(OTP);
  };

  const onResend = () => {
    onResendClick();
    setIsTimerComplete(true);
  };

  const onTimerComplete = () => {
    setIsTimerComplete(false);
  };

  return (
    <div className={styles.form_outer}>
      {isMobile && (
        <div className={styles.form_back}>
          <div className={styles.form_back_btn} onClick={onBackClick}>
            <LeftArrowIcon />
          </div>
        </div>
      )}
      <div className={styles.form_title}>Check your email</div>
      <div className={styles.form_subtitle}>
        We sent a reset link to <strong>contact@dash...com</strong> enter 5
        digit code that mentioned in the email
      </div>
      <OTPInput
        value={OTP}
        onChange={setOTP}
        autoFocus
        OTPLength={5}
        otpType="number"
        disabled={false}
        className={styles.otp_input_wrap}
        inputClassName={styles.otp_input}
        inputStyles={{ width: "58px", height: "50px", margin: "0", textAlign: "center" }}
      />
      <ResendOTP maxTime={120} renderButton={renderButton} renderTime={renderTime} onResendClick={onResend} onTimerComplete={onTimerComplete} />
      {isTimerComplete && (
        <div className={styles.otp_btn_container}>
          <LoadingButton
            type="button"
            loading={!isTimerComplete && loading}
            title={"Verify Code"}
            icon={<RightArrowIcon />}
            onClick={onSubmit}
          />
        </div>
      )}
      {errorMessage && <ErrorMessage message={errorMessage} mt />}
    </div>
  );
};

export default Step2;
